export const PROJECT_PAGE_SIZE = 25;
export const REFRESHED_TIME = 5 * 60 * 1000;
export const PowerBiExportFormat = {
  PDF: 'PDF',
  XLSX: 'XLSX',
} as const;
export type PowerBiExportFormatType =
  (typeof PowerBiExportFormat)[keyof typeof PowerBiExportFormat];

// MVP loads only the CCR report group. Pass the group code selected in the UI when report-group selection is introduced.
export const PowerBiReportGroups = {
  CCR: 'CCR',
};
export const ReportKeys = {
    'PROJECT': 'PROJECT'
};

export const CUSTODIAN_DETAILS_VISUAL_TITLE = 'Custodian Detail';
export const POWER_BI_VISUAL_SELECTOR_SCHEMA =
  'http://powerbi.com/product/schema#visualSelector';